import { Component, EventEmitter, Input, OnInit, Output, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { Observable } from 'rxjs';
import { OrtakService } from '../../../../services/ortak.service';
import { CtlBysIlgiGelenService } from '../ctl-bys-ilgi-gelen.service';
import { CtlBysIlgiGelenAramaService } from './ctl-bys-ilgi-gelen-arama.service';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-bys-ilgi-gelen-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  templateUrl: './ctl-bys-ilgi-gelen-arama.component.html',
  providers:[CtlBysIlgiGelenAramaService],
  styleUrls: ['./ctl-bys-ilgi-gelen-arama.component.scss'],
})
export class CtlBysIlgiGelenAramaComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: CtlBysIlgiGelenAramaService,
    private bysIlgiGelenService:CtlBysIlgiGelenService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.bysIlgiGelenService.gridControlsList$;
    this.bysIlgiGelenService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}
